import { createSlice } from '@reduxjs/toolkit';
import { getJomPayPaymentThunk } from '../../services/jomPayPaymentService/jomPayPaymentThunk';

export type JomPayPaymentData = {
  id: string;
  amount?: number;
  agreementNo?: string;
  referenceNo?: string;
  channel?: string;
  bank?: string;
  payDate?: string;
  loanType?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type JomPayPaymentDataResponse = {
  total: number;
  currentPage: number;
  pageSize: number;
  data: JomPayPaymentData[];
};

export type JomPayPaymentState = {
  jomPayPayment: {
    isLoading: boolean;
    isError: boolean;
    errorMessage: any;
    data: JomPayPaymentDataResponse;
  };
};

const initialState: JomPayPaymentState = {
  jomPayPayment: {
    isLoading: false,
    isError: false,
    errorMessage: '',
    data: {
      total: 0,
      currentPage: 0,
      pageSize: 0,
      data: [],
    },
  },
};

export const jomPayPayment = createSlice({
  name: 'jomPayPayment',
  initialState,
  reducers: {
    JomPayPaymentStateReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJomPayPaymentThunk.pending, (state) => {
        state.jomPayPayment.isLoading = true;
      })
      .addCase(getJomPayPaymentThunk.fulfilled, (state, action) => {
        state.jomPayPayment.isLoading = false;
        state.jomPayPayment.data = action.payload;
      })
      .addCase(getJomPayPaymentThunk.rejected, (state, action) => {
        state.jomPayPayment.isLoading = false;
        state.jomPayPayment.isError = true;
        state.jomPayPayment.errorMessage = action.payload;
      });
  },
});

export const { JomPayPaymentStateReset } = jomPayPayment.actions;

export default jomPayPayment.reducer;
